const systemRouter = {  
  path: 'jde',
  name: 'jde',
  component: () => import('@/views/test/jde.vue')
}

export default systemRouter